import { render, staticRenderFns } from "./SnakeBar.vue?vue&type=template&id=b9511032"
import script from "./SnakeBar.vue?vue&type=script&lang=js"
export * from "./SnakeBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports